import { ComponentProps } from "."
import { Wrapper } from "./styled"

const Button = (props: ComponentProps) => <Wrapper {...props} />

export default Button
